<template>
   <div class="modal-container has-text-centered yScroll">
        <div v-if="!ownerLeaving">
            <div class=" bottom20">
               <div class="has-background-dark top10"> <div class="font17"><img src="@/assets/img/fourDotsLogo.png" width="13"/><span class="left3 has-text-white"> ADD COLLAB MEMBERS</span></div></div>
               <div class="delete is-pulled-right top-22" @click="cancel"></div>
            </div>
            <!-- <div class="top5">Connections:</div> -->
            <div class="has-background-grey-dark groupConnectChooser marginAutod has-text-left pad10 roundedCorners" id="memberList" style="overflow: auto">
                <div v-for="(item, index) in connects" :key="index" ref="groupMembers" :ci="item.id">
                    <input type="checkbox" class="checkbox"/> 
                    &nbsp;<span v-if="item.id_recip == true && item.meOrig">&nbsp;{{item.fName + ' ' + item.lName}}</span>
                    <span v-if="!item.meOrig">&nbsp;{{item.origF + ' ' + item.origL}}</span>
                </div>
                <div class="has-text-centered" v-if="connects.length == 0">No More Connections to Add</div>
            </div>
            <div class="top10"><button class="button is-small is-coolGreen" @click="addMembers">ADD</button></div>
           <!--  <div class="top10 is-size-7">Note: Removing members is coming soon.</div> -->
        </div>
        <div v-if="ownerLeaving" class="top40">Before you can leave this collab you must transfer admin control to another member.</div>

       <br>
        <div class=" bottom20">
               <div class="has-background-dark top10"> <div class="font17"><img src="@/assets/img/fourDotsLogo.png" width="13"/><span class="left3 has-text-white"> REMOVE COLLAB MEMBERS</span></div></div>
            </div>
            <!-- <div class="top5">Connections:</div> -->
            <div class="has-background-grey-dark groupConnectChooser marginAutod has-text-left pad10 roundedCorners" id="memberList" style="overflow: auto">
                <div v-for="(item2, index2) in gmembs" :key="index2" ref="collabMembers" :ci="item2.id_customer">
                    <input type="checkbox" class="checkbox"/> 
                    &nbsp;<span :class="{'has-text-grey-light': item2.active == '0'}">&nbsp;{{item2.fName + ' ' + item2.lName}} {{item2.active == '0' ? '(pending)' : ''}}</span>
                    
                </div>
                <div class="has-text-centered" v-if="gmembs.length == 0">No other collaborators</div>
            </div>
            <div class="top10"><button class="button is-small is-coolGreen" :disabled="gmembs.length == 0" @click="removeMembers">REMOVE</button></div>

        <div class="has-background-dark top40 "> <div class="font17"><img src="@/assets/img/fourDotsLogo.png" width="13"/><span class="left3 has-text-white"> TRANSFER ADMIN CONTROL</span></div></div><br>
        <div class="has-background-grey-dark groupConnectChooser marginAutod has-text-left pad10 roundedCorners" id="memberList" style="overflow: auto">
            <div ><div v-for="(it, ind) in gmembsNoActive">
                <input  type="radio" class="radio" name="tr" :value="it.id_customer" v-model="forTransfer"/> 
            &nbsp;<span >{{it.fName + ' ' + it.lName}}</span></div></div>
            <div class="has-text-centered" v-if="gmembsNoActive.length == 0">No other active collaborators</div>
            </div>
           
            <div class="top10"><button class="button is-small is-coolGreen" @click="transfer" :disabled="gmembs.length == 0 || forTransfer == ''">{{ownerLeaving ? 'TRANSFER & LEAVE' : 'TRANSFER'}}</button></div>
        <br>
        <button class="button is-small" @click="cancel">CANCEL</button>
        <br> <br>
   </div>
</template>


<script>

import ShareTree from '../components/ShareTree'
import { AZEventBus } from '../components/AZEventBus'

export default{
    props: {
        groupId: Number,
        members: Array,
        callBack: Function,
        callBack2: Function,
        rootCollabId: Number,
        groupMembers: Array,
        bundleId: Number,
        ownerLeaving: Boolean,
        caller: Object

    },

    components: {
        ShareTree
    },

    data: function(){
        return {
            connects: [],
            forTransfer: ''
        }
    },
   
    mounted: function(){

        var self = this

        function w(d){
            az.addRemSpinner(false, 'id', 'memberList')

            let arr = []

           
            self.groupMembers.forEach(t => {
                arr.push(t.id_customer ? t.id_customer : '000')
                arr.push(t.owner ? t.owner : '000')
            })

          
            let a = d.r.filter(e => {
                return e.active == 1 && (!arr.includes(e.id_orig2) || !arr.includes(e.id_recip2))
            })

            a.sort()
            self.connects = a
        }

        function n(){
            az.addRemSpinner(false, 'id', 'memberList')
        }

        az.addRemSpinner(true, 'id', 'memberList')
        this.$root.app.apiClient.get('subs/conn/', {}, w, n)
 
    },

    methods: {
        cancel: function(){
            this.$emit('close')
        },
        addMembers: function(){

            let self = this
            let toInclude = [];

             this.$refs.groupMembers.forEach(e => {
               if(e.firstChild.checked){
                   toInclude.push(parseInt(e.attributes.ci.value))
               }
            })

            if(toInclude.length == 0)
                return

            function w(d){
                if(d.newMembers){
                    d.newMembers.forEach(e => {
                        self.$root.app.groupMembers.push(e)
                    })
                }
                self.callBack(d)
            }

            function n(){

            }

            this.$root.app.apiClient.post('subs/data/addcollabmembers', {aclId: this.groupId, toInclude: toInclude, rootCollabId: this.rootCollabId}, w, n)

           
        },

        removeMembers: function(){

            let self = this
            let toInclude = [];

             this.$refs.collabMembers.forEach(e => {
               if(e.firstChild.checked){
                   toInclude.push(e.attributes.ci.value)
               }
            })

            if(toInclude.length == 0)
                return

            function w(d){

                //--remove from group
                if(d = 'ok'){
                    var arr = []
                    toInclude.forEach(a => {
                        var temp = self.$root.app.groupMembers.filter(e => {
                            return a == e.id_customer && e.id_acl == self.groupId
                        })
                        temp.forEach(e => {
                            e.active = '33'
                        })
                        
                        
                        
                    })
                 
                }
                self.callBack(d)

            }

            function n(){

            }

            this.$root.app.apiClient.post('subs/data/removecollabmembers', {aclId: this.groupId, toInclude: toInclude, rootCollabId: this.rootCollabId}, w, n)

        },

        transfer: function(){

            let self = this
            let transferMember

            if(this.forTransfer == '')
                return

           

            function w(d){
                if(d.result){
                    self.callBack2(self.bundleId, self.ownerLeaving ? true : false) //bundle to be deleted
                   
                } else {

                }
            }

            function n(){

            }

            this.$root.app.apiClient.put('subs/data/changeCollabOwner', {collabId: this.groupId, newOwner: this.forTransfer, origId: this.bundleId, ownerLeaving: this.ownerLeaving}, w, n)


        }

    },

    computed: {
        gmembs: function(){
            var self = this;
            return this.groupMembers.filter(e => {
                return e.id_customer != self.$root.app.userAttrs.sub && e.id_customer != e.owner && (e.active == '1' || e.active == '0')
            })
        },

        gmembsNoActive: function(){
            var self = this;
            return this.groupMembers.filter(e => {
                return e.id_customer != self.$root.app.userAttrs.sub && e.id_customer != e.owner && e.active == '1'
            })
        },
       
    }

}
</script>


<style scoped>
    .modal-container{
        max-width: 400px;
    }

    .title{
        margin: 0 50px 0 50px
    }
</style>